<!-- table组件  -->
<template>
  <div class="table-container">
    <el-table
      ref="multipleTable"
      :data="data"
      style="width: 100%"
      :height="tableHeight"
      @selection-change="handleSelectionChange"
      @sort-change="sortChange"
    >
      <el-table-column type="selection" align="center" v-if="showOperation && type" width="45"></el-table-column>
      <!-- table 第一格 序号  -->
      <el-table-column type="index" :label="$t('SerialNo')" v-if="serialNumber" width="80" align="center" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <!-- table  每一列的循环  -->
      <el-table-column
        v-for="(item, index) in columns"
        :key="index"
        :align="item.align? item.align : 'left'"
        :sortable="item.sort"
        :prop="item.attrName"
        :label="item.label"
        :width="item.width"
        :sort-orders="['ascending', 'descending']"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span class="normal-text">{{ scope.row[item.attrName] }}</span>
        </template>
      </el-table-column>
      <!-- 循环操作数据显示历史记录日志 -->
      <el-table-column
        v-if="operation.length > 0 && showOperation && type"
        align="center"
        :label="$t('operationh')"
        :width="operationWidth"
      >
        <template slot-scope="scope">
          <span
            v-for="(item, index) in operation"
            :key="index"
            :class="item.class"
            v-has="'log:data:delete'"
            @click="operateType(item.type, scope.row, scope.$index)"
          >
            <img
              v-if="item.type === 'play' && scope.$index === currentIndex && showIcon"
              class="oprat-icon"
              :src="item.playicon"
              alt=""
            />{{ item.operateName }}
            <img v-if="item.icon" class="oprat-icon" :src="item.icon" alt="" />
          </span>
        </template>
      </el-table-column>
      <!-- 循环操作数据显示 -->
      <el-table-column v-if="operation.length > 0 && !type" align="center" :label="$t('operationh')" :width="operationWidth">
        <template slot-scope="scope">
          <span
            v-for="(item, index) in operation"
            :key="index"
            :class="item.class"
            @click="operateType(item.type, scope.row, scope.$index)"
          >
            <img
              v-if="item.type === 'play' && scope.$index === currentIndex && showIcon"
              class="oprat-icon"
              :src="item.playicon"
              alt=""
            />
            {{ item.operateName }}
            <img v-if="item.icon" class="oprat-icon" :src="item.icon" alt="" />
          </span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { searchMenuCode, warning } from '@/util/common'
import {
  batterysDelete,
  modulesDelete,
  mediaUploadInfoDelete,
  geoFencesDelete,
  mobileDatasDelete,
  callsDelete,
  emergencyHelpDelete,
  operationsDelete,
} from '@/api/log/logDelet'
import { voiceDetectDelete, faceDetectDelete } from '@/api/log'
export default {
  name: 'commontable',
  props: {
    playBtnTime: {
      type: Number,
    },
    /**
     * 表头以及传参
     * { attrName: 'userName', label: '用户名' },
     */
    columns: {
      type: Array,
      default: () => [],
    },
    // table 数据
    data: {
      type: Array,
      default: () => [],
    },
    /**
     * 操作数组
     * {
          operateName: '', 操作名
          icon: require('@/icon/ic_delete.png'), 操作代表图片
          type: 'delect', 操作类型
          IsHad: '', 判断是否有权限
        },
     */
    operation: {
      type: Array,
      default: () => [],
    },
    // 操作栏的宽度
    operationWidth: {
      type: Number,
      default: () => 0,
    },
    numWidth: {
      type: Number,
      default: () => 0,
    },
    // 当前页
    currentPage: {
      type: Number,
      default: () => 0,
    },
    // 当前条/页
    pageSize: {
      type: Number,
      default: () => 0,
    },
    type: {
      type: String,
    },
    // 高度
    tableHeight: {
      type: Number,
      default: () => 595,
    },
    // 是否显示序号栏
    serialNumber: {
      type: Boolean,
      default: () => true,
    }
  },
  data() {
    return {
      showOperation: searchMenuCode('log:data:delete'),
      multipleSelection: [],
      currentIndex: null,

      // 秒来计算要播放的时间
      playInTime: 0,
      clearaudioTime: null,
      // 播放录音icon
      showIcon: false,
    }
  },
  methods: {
    sortChange({ column, prop, order }) {
      this.$emit('sortChange', { column, prop, order })
    },
    // 选择框选择的内容
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleSelectionEmpty() {
      this.$refs.multipleTable.clearSelection()
    },
    // 循环所选列表 过滤需要的内容
    handleDeletList() {
      if (this.multipleSelection.length <= 0) {
        warning(this.$t('selectrecordDelete'))
        return
      }
      if (this.type === 'emergencyHelp' || this.type === 'operation') {
        let helpData = []
        for (let item of this.multipleSelection) {
          helpData.push(item.id)
        }
        this.handleDelets(helpData)
      } else if (this.type === 'Voiceprint') {
        let voiceData = []
        for (let item of this.multipleSelection) {
          voiceData.push(item.id)
        }
        this.handleDelets(voiceData)
      } else if (this.type === 'Faceprint') {
        let faceData = []
        for (let item of this.multipleSelection) {
          faceData.push(item.id)
        }
        this.handleDelets(faceData)
      } else {
        let batterydata = []
        for (let item of this.multipleSelection) {
          batterydata.push({
            userId: item.userId,
            sid: item.sid,
            logTimestamp: item.logTimestamp,
          })
        }
        this.handleDelets(batterydata)
      }
    },
    // 批量删除
    handleDelets(param) {
      this.$confirm(this.$t('deleteCheckedRecord'), '', {
        confirmButtonText: this.$t('determine'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        switch (this.type) {
          case 'battery':
            batterysDelete(param).then(res => {
              if (res.state === 0) {
                this.$emit('getList')
                this.delectTip()
              }
            })
            break
          case 'call':
            callsDelete(param).then(res => {
              if (res.state === 0) {
                this.$emit('getList')
                this.delectTip()
              }
            })
            break
          case 'geoFence':
            geoFencesDelete(param).then(res => {
              if (res.state === 0) {
                this.$emit('getList')
                this.delectTip()
              }
            })
            break
          case 'mediaUpload':
            mediaUploadInfoDelete(param).then(res => {
              if (res.state === 0) {
                this.$emit('getList')
                this.delectTip()
              }
            })
            break
          case 'mobileData':
            mobileDatasDelete(param).then(res => {
              if (res.state === 0) {
                this.$emit('getList')
                this.delectTip()
              }
            })
            break
          case 'module':
            modulesDelete(param).then(res => {
              if (res.state === 0) {
                this.$emit('getList')
                this.delectTip()
              }
            })
            break
          case 'operation':
            operationsDelete(param).then(res => {
              if (res.state === 0) {
                this.$emit('getList')
                this.delectTip()
              }
            })
            break
          case 'Voiceprint':
            voiceDetectDelete(param).then(res => {
              if (res.state === 0) {
                this.$emit('getList')
                this.delectTip()
              }
            })
            break
          case 'Faceprint':
            faceDetectDelete(param).then(res => {
              if (res.state === 0) {
                this.$emit('getList')
                this.delectTip()
              }
            })
            break
          case 'emergencyHelp':
            emergencyHelpDelete(param).then(res => {
              if (res.state === 0) {
                this.$emit('getList')
                this.delectTip()
              }
            })
            break
          default:
        }
      })
    },
    delectTip() {
      this.handleSelectionEmpty()
      this.$message({
        type: 'success',
        message: this.$t('batchDeletionSucceeded'),
      })
    },
    // 修改table header的背景色
    tableHeaderColor() {
      return 'background-color: #F4F4F4;'
    },
    // 倒计时语音动画
    countDown() {
      console.log(this.currentIndex, this.playInTime)
      if (this.playInTime > 0) {
        this.playInTime--

        this.clearaudioTime = setTimeout(() => {
          this.countDown()
        }, 1000)
      } else {
        this.currentIndex = null
        clearTimeout(this.clearaudioTime)
      }
    },
    operateType(type, value, index) {
      this.multipleSelection = []
      this.currentIndex = index
      if (type === 'play') {
        this.showIcon = true
      } else {
        this.showIcon = false
      }
      this.$emit('operate', { type: type, value: value, index: index })
    },
    checkType(type, value) {
      let label = ''
      switch (type) {
        case 'status': //状态：是否启用
          if (value === 1) {
            label = '启用'
          } else {
            label = '禁用'
          }
          break
        case 'bugstatus': //BUG 的状态
          if (value === 1) {
            label = '未关闭'
          } else {
            label = '关闭'
          }
          break
        default:
          label = value
      }
      return label
    },
  },
  watch: {
    playBtnTime: {
      handler() {
        if (this.playBtnTime > 0) {
          this.playInTime = this.playBtnTime
          this.countDown()
        }
      },
      deep: true,
    },
  },
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
.table-container
  position relative
  width 100%
  // height: 590px;
  >>> .el-table__body-wrapper
    overflow-y: auto
    position: relative
    height: 550px
.editClick
  cursor pointer
  color #0E65DD
  word-wrap:break-word;
  img
    vertical-align: middle
    width 14px; /* no */
    height 14px; /* no */
    margin-right 5px
.opreate-btn
  cursor pointer
  font-size 18px
  margin-right 10px
  &:hover
    opacity 0.8
.oprat-icon
  cursor pointer
  width 24px; /* no */
  height 24px; /* no */
.status-dot-grean
  background #6dd400
  width 10px
  height 10px
  margin-right 10px
  border-radius 5px
.status-dot-red
  background #e02020
  width 10px
  height 10px
  margin-right 10px
  border-radius 5px
.del-Click
  color #FF3535
  cursor pointer
// 深色样式
.theme-dark
  .editClick
    color #00DEFF
</style>
